import * as Sentry from "@sentry/react";
import { CUSTOMER_ORDER_SUMMARY_URL } from "../constants/endpoints";
import axiosClient from "./axios";
import type { CustomerBadge } from "../types/customers";

class FetchCustomerRelationsService {
  static async fetchCustomerRelations(
    shopId: string,
    page: number,
    limit: number,
    isPurchased: boolean | null,
    startDate?: string,
    endDate?: string,
    searchTerm?: string,
    badge?: CustomerBadge
  ) {
    const filters: Record<string, unknown> = {};
    if (isPurchased !== null) filters.isPurchased = isPurchased;
    if (startDate) filters.startDate = startDate;
    if (endDate) filters.endDate = endDate;
    if (searchTerm) filters.searchTerm = searchTerm;
    if (badge) filters.badge = badge;

    const body = { shopId, page, limit, filters };

    return Sentry.startSpan(
      {
        op: "http.client",
        name: "POST /admin/shop/customers/order-summary",
      },
      async () => {
        return axiosClient.post(CUSTOMER_ORDER_SUMMARY_URL, body);
      }
    );
  }
}

export default FetchCustomerRelationsService;
